import {Input} from "./Input.js";
import {InputErrorHandler} from "../../util/input-error-handler/index.js";
import {InputValidator} from "../../util/input-validate/inputValidation.js";

export class EmailAuthInput extends Input {
    setup() {
        super.setup();
        this.$props.timer = null;
        this.$props.NOT_NUMERIC_REG = /\D/g
    }

    template() {
        const {addClassName = "", inputId = 'authNumberInput'} = this.$props;
        return `
            <div id="emailAuthInputLayer" class="auth-num-input-wrap">
                 <input id="${inputId}" 
                      type="text" 
                       inputmode="numeric"
                       class="${addClassName}"
                       data-valid="number"
                       data-required-yn='Y' 
                       data-empty-msg="${i18next.t(main.alert.enterWord, {val: $t(common.confirmVerificationCode)})}" 
                       pattern="[0-9]" 
                       data-un-valid-msg="${i18next.t(common.enterDigitOnly)}"
                       placeholder="${i18next.t(common.inputValue, {val: $t(common.confirmVerificationCode)})}" 
                       autocomplete="off"
                       minlength="6"
                       maxlength="6">
                       <span id="authCounter" style="display: none"></span>
               </div>
              <p class="error-txt-wrap">
                <span class = "js-error-txt">${i18next.t(main.alert.verificationNotMatch)}</span> <button id="resendAuthCheckBtn">${i18next.t(dictionary.resend)}</button>
              </p>`
    }
    mounted() {
        $(this.getInputSelector()).focus();
    }

    getInputSelector() {
        const {inputId = "authNumberInput"} = this.$props;
        return `#${inputId}`
    }

    setEvent() {
        const {
            sendEmail = Mutil.noop
        } = this.$props;
        super.setEvent();
        this.addEvent("input", this.getInputSelector(), (e) => {
            const $authNumber = $(`${this.getInputSelector()}`);
            const inputValue = $authNumber.val();
            this.addAuthNumber(inputValue);
        });

        this.addEvent("click", "#resendAuthCheckBtn", async (e) => {
            InputErrorHandler.unActiveErrorModeAboutInput($("#emailAuthInputLayer"))
            sendEmail();
        })
    }

    addAuthNumber(inputValue = '') {
        const $authNumber = $(`${this.getInputSelector()}`);
        $authNumber.val(inputValue.replace(this.$props.NOT_NUMERIC_REG, ''));
    }

    keyUpEventHandlerOfInput(e) {
        const {
            isLast = false,
            submit = Mutil.noop
        } = this.$props;
        if (Mutil.isAvailableKeyCode(e)) {
            return;
        }

        InputErrorHandler.unActiveErrorModeAboutInput($("#emailAuthInputLayer"));
        if (isLast && Mutil.isKey(e, "ENTER")) {
            submit();
            return;
        }

    }

    inputValidate() {
        const $authNumberInput = $(`${this.getInputSelector()}`)
        const $authNumberInputLayer = $authNumberInput.parent();
        const errorJson = InputValidator.getInputErrorJson($authNumberInput)
        const isError = Object.values(errorJson).length > 0;
        if (isError) {
            InputErrorHandler.activeErrorModeAboutInput($authNumberInputLayer, errorJson.errorMessage)
            return false;
        }
        InputErrorHandler.unActiveErrorModeAboutInput($authNumberInputLayer);
        Mutil.mlog(`인증 번호 입력 태그 타당성 검사 ${isError ? "실패!" : "성공!"} >> ${$($authNumberInput).val()}`);
        return !isError;
    }

    startCounter(authLimitMinutes) {
        if(this.$props.timer !== null) {
            clearInterval(this.$props.timer);
        }
        const end = new Date();
        end.setMinutes(end.getMinutes() + Number(authLimitMinutes));
        const _second = 1000;
        const _minute = _second * 60;
        const _hour = _minute * 60;
        const $counter = $("#authCounter");
        $counter.css("display", "block");
        const timer = setInterval(countInterval, 1000);

        this.$props.timer = timer;
        $counter.data("timer", timer);

        function countInterval() {
            const now = new Date();
            const distance = end - now;
            const isFin =  distance < 0;
            const $authNumberInputLayer = $("#emailAuthInputLayer");
            if (isFin) {
                clearInterval(timer);
                InputErrorHandler.activeErrorModeAboutInput($authNumberInputLayer, i18next.t(main.alert.verificationExpired));
                return;
            }
            const isClosed = !$authNumberInputLayer.is(":visible")

            if (isClosed) {
                clearInterval(timer);
                return;
            }

            const minutes = Math.floor((distance % _hour) / _minute);
            let seconds = Math.floor((distance % _minute) / _second);
            if (seconds < 10) seconds = "0" + seconds;
            $counter.text(minutes + ":" + seconds);
        }
    }

}

// main.alert.verificationExpired